/**
 * Lightweight mobile/iOS detection and performance caps.
 * Cached at module level — never changes during a session.
 */

const UA = typeof navigator !== 'undefined' ? navigator.userAgent : '';

export const IS_IOS = /iphone|ipad|ipod/i.test(UA);
export const IS_MOBILE = IS_IOS || /android/i.test(UA) || (typeof window !== 'undefined' && window.innerWidth < 768);

/** Capped device-pixel-ratio: iPhones report 3x which triples canvas pixel count */
export const CAPPED_DPR = IS_IOS ? 1.5 : Math.min(window?.devicePixelRatio ?? 1, 2);

/** Target frame interval for canvas loops — 30fps on mobile, 60fps on desktop */
export const FRAME_INTERVAL_MS = IS_MOBILE ? 33.3 : 16.6;
